<div class="dialog-container">
  <h1 class="text-dark text-xl" mat-dialog-title>
    {{ isEditMode ? 'Modifica Documento MMSS' : 'Carica Documento MMSS' }}
  </h1>
  <mat-dialog-content>
    <app-form-upload-document
      [dialogRef]="dialogRef"
      [modalTrigger$]="modalTrigger$"
      [isEditMode]="isEditMode"
      [document]="document"
    ></app-form-upload-document>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button class="btn btn-secondary" mat-button (click)="closeDialog()">Chiudi</button>
  </mat-dialog-actions>
</div>
